import { render, staticRenderFns } from "./tablaMayoreo.vue?vue&type=template&id=1055e4ee&scoped=true&"
import script from "./tablaMayoreo.vue?vue&type=script&lang=js&"
export * from "./tablaMayoreo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1055e4ee",
  null
  
)

export default component.exports